import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initSalaryListImport');
    $(".attachment_attributes_uri").on('change', function () {
      const el = this as HTMLInputElement;
      if (el.files) {
        let selected = '';
        for (let i = 0; i < el.files.length; i++) {
          selected += el.files[i].name + '\n';
        }
        $(this).parent().parent().parent().find('.selected-files').val(selected);
        $('.selected-file-view').show(300);
      }
    });
  }
}
